var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content search-content" },
        [
          _c("search-com", {
            attrs: { type: "" },
            on: {
              outputSearchData: _vm.receiveSearchData,
              searchBasic: function ($event) {
                return _vm.getStatistics($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.baseData.loading,
              expression: "baseData.loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c(
            "div",
            { staticClass: "base-data-list" },
            [
              _vm._l(_vm.baseData.list, function (item, index) {
                return [
                  _c("basic-data", {
                    key: index,
                    attrs: { basicDataItem: item, basicDataItemIndex: index },
                  }),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c("div", { staticClass: "content sale-chart" }, [
        _c("div", { staticClass: "sale-chart-left" }, [
          _c("h3", { staticClass: "card-title" }, [
            _c(
              "label",
              [
                _vm._v(" " + _vm._s(_vm.trend.title) + " "),
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content:
                        "订单应收总额，不含未提交、取消、审核不通过订单金额数",
                      placement: "top",
                    },
                  },
                  [_c("i", { staticClass: "el-icon-question" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "staff-button-list" },
              [
                _c("search-com-company", {
                  staticClass: "search-company",
                  attrs: {
                    type: "company",
                    dateArr: _vm.trend.dateArr,
                    type: _vm.trend.type,
                  },
                  on: { outputSearchData: _vm.receiveSearchData },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.trend.loading,
                  expression: "trend.loading",
                },
              ],
              staticClass: "card-body",
            },
            [
              _c("total-sales", {
                attrs: {
                  config: _vm.trend.config,
                  baseData: _vm.trend.baseData,
                  dataList: _vm.trend.dataList,
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.staffTableConfigs.loading,
                expression: "staffTableConfigs.loading",
              },
            ],
            staticClass: "sale-chart-right",
          },
          [
            _c("h3", { staticClass: "card-title" }, [
              _c(
                "label",
                [
                  _vm._v(" 员工排行榜 "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "不含未提交及已关闭、审核不通过的订单数据",
                        placement: "top",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "staff-button-list" },
                [
                  _c("el-button", {
                    staticClass: "download-table",
                    attrs: { size: "small", icon: "el-icon-download" },
                    on: {
                      click: function ($event) {
                        return _vm.onDownload("staff")
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("search-com-company", {
              staticClass: "search-company",
              attrs: {
                type: "company",
                type: _vm.staffTableConfigs.type,
                dateArr: _vm.staffTableConfigs.dateArr,
              },
              on: { outputSearchData: _vm.receiveSearchData },
            }),
            _c("data-board-table", {
              attrs: {
                dataList: _vm.staffTableConfigs.list,
                config: _vm.staffTableConfigs.config,
                heightStr: _vm.staffTableConfigs.heightStr,
                sortObj: _vm.orgCodeTableConfigs.sortObj,
              },
            }),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.staffTableConfigs.page.pageNo,
                "page-size": _vm.staffTableConfigs.page.pageSize,
                layout: "total, prev, pager, next",
                total: _vm.staffTableConfigs.page.totalNum,
              },
              on: {
                "size-change": _vm.rankingCurrentChange,
                "current-change": _vm.rankingCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.staffTableAchievement.loading,
              expression: "staffTableAchievement.loading",
            },
          ],
          staticClass: "content achievement",
        },
        [
          _c("h3", { staticClass: "card-title" }, [
            _c(
              "label",
              [
                _vm._v("近一年员工业绩 "),
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "不含未提交及已关闭、审核不通过的订单数据",
                      placement: "top",
                    },
                  },
                  [_c("i", { staticClass: "el-icon-question" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "staff-button-list" },
              [
                _c("el-button", {
                  staticClass: "download-table",
                  attrs: { size: "small", icon: "el-icon-download" },
                  on: {
                    click: function ($event) {
                      return _vm.onDownload("achievement")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c("data-board-table", {
            attrs: {
              dataList: _vm.staffTableAchievement.list,
              config: _vm.staffTableAchievement.config,
              sortObj: _vm.staffTableAchievement.sortObj,
            },
            on: { tableShowDetail: _vm.showDetail },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.subTitle
            ? _c("template", { slot: "title" }, [
                _c("div", { staticClass: "dialog-slot-title" }, [
                  _c("label", [_vm._v(_vm._s(_vm.dialog.title))]),
                  _c("span", [
                    _vm._v(
                      "( " +
                        _vm._s(_vm.staffTableAchievementDetail.month) +
                        " )"
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.dialog.type === "performanceStatistics"
            ? [
                _c("data-board-table", {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    dataList: _vm.staffTableAchievementDetail.page.list,
                    config: _vm.staffTableAchievementDetail.list,
                    sortObj: _vm.staffTableAchievementDetail.sortObj,
                  },
                }),
                _c(
                  "div",
                  { staticClass: "page" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page":
                          _vm.staffTableAchievementDetail.page.pageNo,
                        "page-sizes": [3, 5, 10, 20, 50],
                        "page-size":
                          _vm.staffTableAchievementDetail.page.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.staffTableAchievementDetail.page.totalNum,
                      },
                      on: {
                        "size-change": _vm.staffDetailSizeChange,
                        "current-change": _vm.staffDetailCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "performanceStatistics-download",
                    attrs: { size: "small", type: "primary", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.onDownload("achievementDetail")
                      },
                    },
                  },
                  [_vm._v("下载 ")]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("首页")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }